import { action, computed } from 'mobx';
import PagedCollection from 'core/model/PagedCollection';

const VIEW_DROPDOWN_DISCREET_FILTER_NAME = 'view-compartments-dropdown';

class CompartmentFilterCollection extends PagedCollection {
  @action
  filter(query = undefined, options = {}) {
    if (query !== undefined) {
      this.resetDiscreteFilters();
      super.filter(query, options);
      this.applyPagination();
    }

    if (query === undefined) {
      super.filter(query, options);
    }

    return this.models;
  }

  getSortValue = (field, model) => {
    const value = model.get(field);
    return value;
  };

  @computed
  get selectedCompartmentIds() {
    return this.selectedArray.map((model) => model.get('id')) ?? [];
  }

  @action
  showAllCompartments() {
    this.removeDiscreteFilter(VIEW_DROPDOWN_DISCREET_FILTER_NAME);

    this.applyPagination();
  }

  @action
  selectCompartments(compartmentIds) {
    this.clearSelection();

    compartmentIds.forEach((id) => {
      this.get(id)?.select({ multi: true });
    });

    this.applyPagination();
  }

  @action
  addGroupFilter(compartmentIds) {
    this.selectCompartments(compartmentIds);
    this.addDiscreteFilter({
      type: 'group-dropdown',
      fn: (compartmentModel) => compartmentIds.includes(compartmentModel.get('id'))
    });

    this.applyPagination();

    this.selectAll({ multi: true });
  }

  @action
  removeGroupFilter() {
    this.removeDiscreteFilter('group-dropdown');

    this.applyPagination();
  }

  @action
  showSelectedCompartments() {
    this.addDiscreteFilter({
      type: VIEW_DROPDOWN_DISCREET_FILTER_NAME,
      fn: (compartmentModel) => compartmentModel.isSelected
    });

    this.applyPagination();
  }

  @action
  selectAll(options) {
    // when selecting all, unselect currently selected models to ensure everything is selected
    if (this.selectedSize > 0 && !this.isAllSelected) {
      this.clearSelection();
    }

    this.original.forEach((model) => {
      // when unselecting all, only unselect models that are currently selected
      if (this.selectedSize > 0 && model.isSelected) {
        model.select(options);
      }

      if (this.selectedSize === 0 && !model.isSelected) {
        model.select(options);
      }
    });
  }

  applyPagination() {
    this.calculatePageCount();
    this.applyPageChangeFilter();
  }

  @action
  reset(options = {}) {
    super.reset(options);
    this.clearSelection();
  }

  @action
  resetDiscreteFilters() {
    super.resetDiscreteFilters();
    this.applyPagination();
  }
}

export default CompartmentFilterCollection;
